// DEPENDENCIES
import React, { useState, useEffect } from "react";
import dayjs from "dayjs";

// CSS
import "./DownloadSingleSpecDialog.css";

// MSAL
import { useMsal } from "@azure/msal-react";

// API IMPORTS
import { postAPICall } from "../../../../config/apiCalls";

// MUI COMPONENTS
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { LinearProgress, Typography } from "@mui/material";

// MUI ICONS

// CUSTOM COMPONENTS

// CONSTANTS
import { convertToPST } from "../../../../constants/dateTime";

// OTHER
// To convert the date to UTC
// var utc = require("dayjs/plugin/utc");
// dayjs.extend(utc);

// REACT COMPONENT
const DownloadSingleSpecDialog = (props) => {
	// MSAL
	const { instance, accounts } = useMsal();

	// STATES
	const [progress, setProgress] = useState(0);
	const [progressMessage, setProgressMessage] = useState("");

	// USE EFFECT
	useEffect(() => {
		if (props.open) {
			generateDocument();
		}
	}, [props.open]);

	// INPUT HANDLERS

	// Button Handlers
	const generateDocument = async () => {
		setProgress(0); // this is the percentage
		setProgressMessage("Generating...");

		try {
			// Create Each Spec PDF:
			setProgressMessage("Creating Spec...");
			setProgress(50);

			const tempSelectedSpecsRes = await postAPICall(
				instance,
				accounts[0],
				"/api/convert/html-to-pdf",
				{
					htmlContent: props.selectedSpecification.content,
					property: "",
					address: "",
					date: convertToPST(dayjs.utc(new Date()).toISOString()),
					subtitle: "[DRAFT]",
					title: props.selectedSpecification.title,
					spec_title:
						"SECTION" + " " + props.selectedSpecification.division,
					spec_subtitle: props.selectedSpecification.title,
					include_footer: true,
					include_header: true,
				}
			);

			// Automatically open the generated PDF URL in a new tab
			if (tempSelectedSpecsRes.data.Files.length > 0) {
				window.open(tempSelectedSpecsRes.data.Files[0].Url, "_blank");
			}
		} catch (error) {
			console.log("Error in submitButtonClicked: ", error);
		}

		setProgressMessage("Cleaning Up...");
		setProgress(100);

		formClosed();
	};

	// HELPER FUNCTIONS
	const formClosed = () => {
		props.DownloadSingleSpecDialogClosed();
		setProgress(0);
		setProgressMessage("");
	};

	// RENDER
	return (
		<Dialog
			id="downloadSingleSpecDialog"
			open={props.open}
			fullWidth
			disableEscapeKeyDown
		>
			<DialogTitle id="downloadSingleSpecDialogTitle">
				Generating Document
			</DialogTitle>
			<DialogContent id="downloadSingleSpecDialogContent">
				<div className="loadingBarContainer">
					<LinearProgress variant="determinate" value={progress} />
					<Typography>{progressMessage}</Typography>
				</div>
			</DialogContent>
		</Dialog>
	);
};

// EXPORT
export default DownloadSingleSpecDialog;
